import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { JobInvoicing } from '~hooks/useJob/models';

const getMarginProps = (margin: number | null) => {
  if (margin === null) {
    return { color: 'text.primary', text: '-' };
  }

  const formatted = Math.abs(margin).toFixed(2);

  if (margin > 0) {
    return { color: 'success.main', text: `+$${formatted}` };
  }

  if (margin < 0) {
    return { color: 'error.main', text: `-$${formatted}` };
  }

  return { color: 'text.primary', text: `$${formatted}` };
};

interface MarginColumnProps {
  job: JobInvoicing;
  sx?: SxProps<Theme>;
}

export default function MarginColumn({ job, sx }: MarginColumnProps) {
  const { receivableInvoice, payableInvoice } = job;

  let margin = null;

  if (receivableInvoice && payableInvoice) {
    margin = receivableInvoice.totalAmount - payableInvoice.totalAmount;
  }

  const { color, text } = getMarginProps(margin);

  return (
    <Box sx={sx}>
      <OverflowAwareText sx={{ color }} fontWeight={700}>
        {text}
      </OverflowAwareText>
    </Box>
  );
}
